import _extends from '@babel/runtime/helpers/extends';
import { Typography } from '@archer-technologies/ui-components';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { useMemo, createElement } from 'react';

var hasComma = function hasComma(dateValue) {
  var expression = /[,]/g;
  return expression.test(dateValue);
};

var createDateFormatter = function createDateFormatter(dateTimeLocale) {
  return function (_ref) {
    var value = _ref.value;
    var date = '';

    if (value) {
      date = dateTimeLocale ? dateTimeLocale(value) : value.toLocaleString('en-US');
    }

    return /*#__PURE__*/createElement(Typography, {
      variant: "body1",
      color: "textPrimary",
      align: hasComma(date) ? 'left' : 'right'
    }, date);
  };
};

var DateTypeProvider = function DateTypeProvider(props) {
  var dateTimeLocale = props.dateTimeLocale;
  var DateFormatter = useMemo(function () {
    return createDateFormatter(dateTimeLocale);
  }, [dateTimeLocale]);
  return /*#__PURE__*/createElement(DataTypeProvider, _extends({
    formatterComponent: DateFormatter
  }, props));
};

export { DateTypeProvider, createDateFormatter };